(() => {
  const defaultArchiveUrl = '/search?q=%2A&type=article&view=article-archive&sort_by=created-descending';

  function prepareArchiveForm(form) {
    if (form.dataset.archiveFormInitialized === 'true') return;
    form.dataset.archiveFormInitialized = 'true';
    const query = form.querySelector('input[name="q"]');
    const sort = form.querySelector('[data-article-sort]');

    form.addEventListener('submit', () => {
      if (query && !query.value.trim()) query.value = '*';
    });
    sort?.addEventListener('change', () => form.requestSubmit());
  }

  async function loadLatestArticles(container) {
    if (container.dataset.latestArticlesInitialized === 'true') return;
    container.dataset.latestArticlesInitialized = 'true';
    const status = container.parentElement?.querySelector('[data-latest-articles-status]');
    const archiveUrl = container.dataset.archiveUrl || defaultArchiveUrl;

    try {
      const response = await fetch(archiveUrl, { credentials: 'same-origin', headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error(`Article archive request failed: ${response.status}`);
      const responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
      const articles = [...responseDocument.querySelectorAll('[data-article-card]')].slice(0, 3);

      container.replaceChildren(...articles.map((article) => article.cloneNode(true)));
      container.setAttribute('aria-busy', 'false');
      if (status) status.textContent = articles.length ? '' : 'No published articles are available yet.';
    } catch (error) {
      container.setAttribute('aria-busy', 'false');
      if (status) status.textContent = 'Latest articles are temporarily unavailable. Open the archive to continue.';
    }
  }

  function initialize(scope = document) {
    scope.querySelectorAll?.('[data-article-archive-form]').forEach(prepareArchiveForm);
    scope.querySelectorAll?.('[data-latest-articles]').forEach(loadLatestArticles);
  }

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
